import type { ThemeWithoutTokens } from '../theme.types';

export const buttonTokens = (theme: ThemeWithoutTokens) =>
  ({
    buttonFontSize: theme.typography.fontSize.s,
    buttonFontFamily: theme.typography.fontFamily.regular,
    buttonFontWeight: theme.typography.fontWeight.bold,
    buttonBorderRadius: theme.radiuses.m,
    buttonDisabledBackgroundColor: theme.colors.disabled.background,
    buttonDisabledTextColor: theme.colors.disabled.text,
    buttonDisabledBorderColor: theme.colors.disabled.background,
    buttonBorder: '1px solid transparent',
    buttonPrimaryBackgroundColor: theme.colors.primary.normal,
    buttonPrimaryTextColor: theme.colors.body.textLight,
    buttonOutlineTextColor: theme.colors.primary.normal,
    buttonOutlineHoverTextColor: theme.colors.primary.dark,
    buttonOutlineFocusTextColor: theme.colors.primary.darker,
    buttonPrimaryHoverBackgroundColor: theme.colors.primary.dark,
    buttonPrimaryFocusBackgroundColor: theme.colors.primary.darker,
    buttonSecondaryBackgroundColor: theme.colors.body.background,
    buttonSecondaryTextColor: theme.colors.body.text,
    buttonOutlineBorder: `1px solid ${theme.colors.primary.normal}`,
    buttonOutlineBorderHover: `1px solid ${theme.colors.primary.dark}`,
    buttonOutlineBorderFocus: `1px solid ${theme.colors.primary.darker}`,
    buttonOutlineBorderActive: `1px solid ${theme.colors.primary.normal}`,
    buttonSecondaryBorder: `1px solid ${theme.colors.border}`,
    buttonSecondaryHoverBorder: `1px solid ${theme.palette.grey300}`,
    buttonSecondaryFocusBorder: `1px solid ${theme.palette.grey400}`,
    buttonSecondaryDangerBackgroundColor: theme.colors.body.background,
    buttonSecondaryDangerTextColor: theme.colors.danger.normal,
    buttonSecondaryDangerBorder: `1px solid ${theme.colors.danger.normal}`,
    buttonSecondaryDangerHoverBackgroundColor: theme.colors.danger.light,
    buttonSecondaryDangerFocusTextColor: theme.colors.danger.dark,
    buttonSecondaryDangerFocusBorder: `1px solid ${theme.colors.danger.dark}`,

    // Small
    buttonSmallLineHeight: theme.typography.lineHeight.xs,
    buttonSmallPaddingWithText: `${theme.space.component.y.s} ${theme.space.component.x.s}`,
    buttonSmallPaddingWithIconOnly: `${theme.space.component.y.s} ${theme.space.component.x.xs}`,
    // Medium
    buttonMediumLineHeight: theme.typography.lineHeight.xs,
    buttonMediumPaddingWithText: `${theme.space.component.y.s} ${theme.space.component.x.m}`,
    buttonMediumPaddingWithIconOnly: `${theme.space.component.y.s} ${theme.space.component.x.s}`,
    // Large
    buttonLargeLineHeight: theme.typography.lineHeight.xs,
    buttonLargePaddingWithText: `${theme.space.component.y.m} ${theme.space.component.x.l}`,
    buttonLargePaddingWithIconOnly: `${theme.space.component.y.m} ${theme.space.component.x.m}`,
    // XLarge
    buttonXLargeLineHeight: theme.typography.lineHeight.m,
    buttonXLargePaddingWithText: `${theme.space.component.y.m} ${theme.space.component.x.xl}`,
    buttonXLargePaddingWithIconOnly: `${theme.space.component.y.m} ${theme.space.component.x.m}`,
  }) as const;
